import { render, staticRenderFns } from "./PeDetailRail.vue?vue&type=template&id=b41751e2&"
import script from "./PeDetailRail.vue?vue&type=script&lang=js&"
export * from "./PeDetailRail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports